import React from 'react';
import { LoadMore } from 'Components/molecules/LoadMore';

export const getLoadMore = config => (
  <LoadMore
    label={config.label || 'Load More'}
    load={config.loadMore || (() => {})}
    isLoading={config.isLoading || false}
    extraClassNames={config.extraClassNames || {}}
    href={config.href || null}
  />
);
